import React, { useEffect, useState } from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Form,
  Select,
  Upload,
  Row,
  Col,
  Divider,
  Card,
} from 'antd'
import {
  EyeOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import axios from 'axios'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'

import {
  GetJobPost,
  CreateJobPost,
  DeleteJobPost,
  GetJobCategorysMaster,
  GetJobPostByAlumni,
  IMG_BASE_URL3,
} from '../../AllAPI/AdminAPI'
import TextArea from 'antd/es/input/TextArea'

const { Option } = Select

export default function JobPost() {
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [form] = Form.useForm()

  const [fileList, setFileList] = useState([])
  const [categories, setCategories] = useState([])

  const [isViewModalOpen, setIsViewModalOpen] = useState(false)
  const [selectedJob, setSelectedJob] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedJobId, setSelectedJobId] = useState(null)

  const year = JSON.parse(sessionStorage.getItem('BoardingYear'))

  // ===== DELETE =====

  const openDeleteModal = (id) => {
    setSelectedJobId(id)
    setIsDeleteModalOpen(true)
  }

  const confirmDelete = async () => {
    if (!selectedJobId) return

    try {
      const res = await axios.delete(`${DeleteJobPost}/${selectedJobId}`)
      if (res.data === 'DELETED') {
        toast.success('Deleted successfully')
      }
      fetchJobs()
    } catch {
      toast.error('Delete failed')
    } finally {
      setIsDeleteModalOpen(false)
      setSelectedJobId(null)
    }
  }

  // ===== FETCH JOBS =====
  const fetchJobs = async () => {
    try {
      setLoading(true)
      const res = await axios.get(`${GetJobPost}/${year}`)
      setData(res.data || [])
      setFilteredData(res.data || [])
    } catch {
      toast.error('Failed to load jobs')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchJobs()
  }, [])

  // ===== SEARCH =====
  useEffect(() => {
    const filtered = data.filter((item) =>
      item.job_title?.toLowerCase().includes(searchText.toLowerCase()),
    )
    setFilteredData(filtered)
  }, [searchText, data])

  // ===== TABLE COLUMNS =====
  const columns = [
    {
      title: 'Sr No',
      key: 'srno',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Job Title',
      dataIndex: 'job_title',
    },
    {
      title: 'Category',
      render: (_, record) => record.job_category_name?.category_name || '-',
    },
    {
      title: 'Experience',
      dataIndex: 'experience',
    },
    {
      title: 'Industry Name',
      dataIndex: 'industry_name',
    },
    {
      title: 'Action',
      render: (_, record) => (
        <>
          <Button
            title="View"
            icon={<EyeOutlined />}
            onClick={() => openViewModal(record)}
            className="me-1"
          />

          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => openDeleteModal(record.id)}
          />
        </>
      ),
    },
  ]

  const openViewModal = (record) => {
    setSelectedJob(record)
    setIsViewModalOpen(true)
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Job Title': item.job_title,
      Category: item.job_category_name?.category_name || '-',
      Experience: item.experience,
      'Industry Name': item.industry_name,
      Qualification: item.qualification,
      Vacancy: item.vaccancy,
      Contact: item.contact,
      Description: item.discription,
      'Posted By': item.alumini?.fullName || '-',
      Email: item.alumini?.email || '-',
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 25 },
      { wch: 20 },
      { wch: 30 },
      { wch: 25 },
      { wch: 12 },
      { wch: 18 },
      { wch: 60 },
      { wch: 30 },
      { wch: 35 },
    ]

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Job Posts')

    XLSX.writeFile(workbook, 'Job_Post_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8">
          {/* HEADER */}
          <div className="header-row">
            <h2 className="page-title">Job Post</h2>
          </div>

          {/* SEARCH + ADD */}
          <div
            className="d-flex justify-content-between align-items-center mb-3 flex-wrap"
            style={{ gap: '10px' }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>

            <Input
              placeholder="Search Job..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          {/* TABLE */}
          <Table
            columns={columns}
            dataSource={filteredData}
            rowKey="id"
            bordered
            loading={loading}
            pagination={{ pageSize: 10 }}
            className="shadow border rounded"
            scroll={{ x: 'max-content' }}
          />
        </div>

        <div className="col-12 col-md-2"></div>
      </div>

      {/* ===== VIEW MODAL ===== */}
      <Modal
        title={null}
        open={isViewModalOpen}
        onCancel={() => setIsViewModalOpen(false)}
        footer={null}
        width={700}
      >
        {selectedJob && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Job Post Details
            </h3>
            <Card
              bordered={false}
              className="border"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  <b>Job Title</b>
                  <div>{selectedJob.job_title}</div>
                </Col>

                <Col xs={24} md={12}>
                  <b>Category</b>
                  <div>{selectedJob.job_category_name?.category_name}</div>
                </Col>

                <Col xs={24} md={12}>
                  <b>Experience</b>
                  <div>{selectedJob.experience}</div>
                </Col>

                <Col xs={24} md={12}>
                  <b>Industry</b>
                  <div>{selectedJob.industry_name}</div>
                </Col>

                <Col xs={24} md={12}>
                  <b>Qualification</b>
                  <div>{selectedJob.qualification}</div>
                </Col>

                <Col xs={24} md={12}>
                  <b>Vacancy</b>
                  <div>{selectedJob.vaccancy || '-'}</div>
                </Col>

                <Col xs={24} md={12}>
                  <b>Contact</b>
                  <div>{selectedJob.contact}</div>
                </Col>

                <Col xs={24}>
                  <b>Description</b>
                  <div>{selectedJob.discription}</div>
                </Col>
              </Row>

              <Divider />

              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  <b>Posted By</b>
                  <div>{selectedJob.alumini?.fullName}</div>
                </Col>

                <Col xs={24} md={12}>
                  <b>Email</b>
                  <div>{selectedJob.alumini?.email}</div>
                </Col>
              </Row>

              {selectedJob.jobpost_image && (
                <>
                  <Divider />
                  <div>
                    <b>Image</b>
                    <div style={{ marginTop: 10 }}>
                      <img
                        src={`${IMG_BASE_URL3}${selectedJob.jobpost_image}`}
                        alt="img"
                        style={{
                          width: '100%',
                          objectFit: 'cover',
                          borderRadius: 8,
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </Card>
          </div>
        )}
      </Modal>

      {/* ===== DELETE MODAL ===== */}
      <Modal
        title="Confirm Delete"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        footer={[
          <Button onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>,
          <Button type="primary" danger onClick={confirmDelete}>
            Yes, Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to delete this job?</p>
        <p>This action cannot be undone.</p>
      </Modal>
    </div>
  )
}
